export default {
  methods: {
    handleError(error) {
      console.log(error);
      if (!error.response) {
        // this.generateToast(
        //   "An error occured while processing your request, please check your internet connection and try again",
        //   "error"
        // );
      } else {
        if (error.response.data.error) {
          if (error.response.data.error.errors) {
            let errors = error.response.data.error.errors;
            let errorList = [];
            errors.forEach((error) => {
              errorList.push(error.message);
            });
            let errorString = errorList.toString();
            this.generateToast(errorString, "error");
          } else {
            this.generateToast(error.response.data.error, "error");
          }
        } else if (error.response.data.message) {
          this.generateToast(error.response.data.message, "error");
        } else if (error.response.data.msg) {
          this.generateToast(error.response.data.msg, "error");
        } else {
          console.log(error);
          this.generateToast(
            "An error occured while processing your request, please try again",
            "error"
          );
        }
      }
    },
    logResponse(response) {
      console.log(response);
    },
    log(log) {
      console.log(log);
    },
    generateToast(description, toastType) {
      // console.log("Toast should be shown");
      this.$store.dispatch("showToast", {
        title: toastType == "success" ? "Success" : "Error",
        description: description,
        type: toastType == "success" ? "success" : "danger",
        display: true,
      });
    },
  },
};
